import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Settings } from 'src/app/interfaces/settings';
import { AdverticalService } from 'src/app/services/adverticalService/advertical.service';
import { LanguageService } from 'src/app/services/languageService/language.service';
import { environment } from 'src/environments/environment';
declare var shaka: any;

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.less']
})
export class PlayerComponent implements OnInit {
  @Input() data;
  @Output() playerEvents = new EventEmitter();
  video;
  shakaPlayer;
  openCoWatch = false;
  currentSlot;
  ui;
  oldListeners = false;
  constructor(private adverticalService: AdverticalService, private languageService: LanguageService) { }

  ngOnInit(): void {
    // Get Preroll Video Add
    this.adverticalService.getVideoAd("Pre_Roll", "VIDEO_AD").then(resp => {
      this.initShaka();
    });
  }

  /* Shaka */
  /** Shaka Checks before initialize the shaka player  */
  initShaka() {
    shaka.polyfill.installAll();
    if (shaka.Player.isBrowserSupported()) {
      this.initShakaPlayer();
    } else {
      console.error('Browser not supported!');
    }
  }

  /** Initialize Shaka Player */
  private initShakaPlayer() {
    let self = this;
    this.video = document.getElementById('video');
    this.shakaPlayer = new shaka.Player(this.video);
    this.ui = new shaka.ui.Overlay(this.shakaPlayer, document.getElementById('videoPlayerContainer'), this.video);
    this.ui.configure(this.getUIConfig());
    console.dir(this.data);

    // Enable Clear Key DRM
    if (this.data?.video?.isProtected) {
      this.shakaPlayer.configure({
        drm: {
          servers: {
            //'org.w3.clearkey': environment.drm.server,
            'com.widevine.alpha': 'https://lic.staging.drmtoday.com/license-proxy-widevine/cenc/?specConform=true',
          }
        }
      });
    }

    // Change to Language in setting to be the same as the UI is
    this.changeMenuLanguage(this.ui);

    // Load Shaka Player
    let bookmark = this.data.bookmarkInfo && this.data.bookmarkInfo.seek ? this.data.bookmarkInfo.seek / 1000 : 0;

    if (this.data.videoType == "trailer" || this.data.bookmarkInfo.percentage >= 98) {
      bookmark = 0;
    }

    let licenseToken = this.data?.video?.licenseToken;
    // Add extra headers for CORS
    this.shakaPlayer.getNetworkingEngine().registerRequestFilter(function (type, request) {
      //if (type == shaka.net.NetworkingEngine.RequestType.LICENSE) {

      //}
      if (type == shaka.net.NetworkingEngine.RequestType.LICENSE) {
        request.headers["x-dt-auth-token"] = licenseToken;
        //request.headers["x-dt-custom-data"] = "eyJ1c2VySWQiOiAicHVyY2hhc2UiLCAibWVyY2hhbnQiOiAiY2xpZW50X2RldiIsICJzZXNzaW9uSWQiOiAiZGVmYXVsdCJ9";
      } else {
        request.allowCrossSiteCredentials = true;
      }
    });

    // Extra Configuration
    this.shakaPlayer.configure({
      streaming: {
        jumpLargeGaps: true
      }
    })

    // Load Video
    this.shakaPlayer.load(this.data.video.playUrl, bookmark, this.data.videoMimeType).then(function () {
      console.log('The video has now been loaded!');

      // If there are no old listeners and them
      if (!self.oldListeners) {
        self.changeSubtitlesStyle();
        self.setVideoListeners();
      }
    }).catch(error => { this.onError(error) });
  }

  /** Returns the configuration for the UI */
  private getUIConfig() {
    let controlPanelElements = ['play_pause', 'time_and_duration', 'mute', 'volume', 'spacer', 'overflow_menu', 'fullscreen'];
    //Documentation: https://shaka-player-demo.appspot.com/docs/api/shaka.extern.html#.UIConfiguration
    if (environment.enableCoWatch) {
      this.createCoWatchButton();
      controlPanelElements.splice(5, 0, 'cowatch');
      controlPanelElements.join(" ");
    }
    return {
      showUnbufferedStart: true,
      addBigPlayButton: false,
      enableFullscreenOnRotation: true,
      controlPanelElements: controlPanelElements,
      overflowMenuButtons: ['captions', 'quality'], //, 'language', 'picture_in_picture', 'playback_rate', 'statistics'
      addSeekBar: true,
      enableTooltips: false,
      seekBarColors: {
        base: 'rgba(' + environment.playerThemeColor + ', 0.3)',
        buffered: 'rgba(' + environment.playerThemeColor + ', 0.54)',
        played: 'rgb(' + environment.playerThemeColor + ')',
      },
      volumeBarColors: {
        base: 'rgba(' + environment.playerThemeColor + ', 0.3)',
        level: 'rgb(' + environment.playerThemeColor + ')'
      }
    };
  }

  /** Log errors. */
  private onError(error) {
    console.error('Error code', error.code, 'object', error);
  }

  /** Extract the shaka.util.Error object from the event. */
  private onErrorEvent(event) {
    this.onError(event.detail);
  }

  /** Setup player listeners */
  setVideoListeners() {
    if (!this.video) { }
    let self = this;
    this.video.addEventListener("ended", function () { self.playerEvents.emit({ type: "VideoEnd" }) });
    this.shakaPlayer.addEventListener('error', this.onErrorEvent);

    // Timeupdate listener
    this.video.addEventListener("timeupdate", function (e) {
      let currentTime = e.srcElement.currentTime;

      // Check if there is any advertising slot for this second
      if (self.data.media?.adSlots) {
        let adSlot: any = self.data.media.adSlots.find(obj => {
          return obj.slot == parseInt(currentTime);
        });
        if (adSlot && self.currentSlot != parseInt(currentTime)) {
          self.currentSlot = parseInt(currentTime);
          self.getBannerAd(adSlot);
        }
      }
    });
  }

  /** Shaka Player Close Video Player */
  closeVideo() {
    this.removeSubtitlesStyle();
    return new Promise(resolve => {
      const percentage = parseInt(((this.video.currentTime / this.video.duration) * 100).toString());
      const videoInfo = {
        seek: parseInt((this.video.currentTime * 1000).toString()),
        duration: this.video.duration,
        percentage: percentage > 95 ? 100 : percentage == 0 ? 1 : percentage
      }
      this.ui.destroy();
      this.shakaPlayer.destroy().then(resp => {
        resolve(videoInfo);
      });
    });
  }

  /** Change Shaka Menu Language to Greek */
  private async changeMenuLanguage(ui) {
    if (this.languageService.getLanguage() != "en") {
      const controls = ui.getControls();
      const localization = controls.getLocalization();
      const response = await fetch('assets/i18n/settings/' + this.languageService.getLanguage() + '.json');     // <----- JSON translation URL here
      const translations = await response.json();
      const translation_map = new Map(Object.entries(translations));
      localization.insert('el', translation_map);
    }
  }

  /** Change the subtitles style based on the accessibility saved configuration  */
  private changeSubtitlesStyle() {
    if (localStorage.getItem("accessibility")) {
      let settings: Settings = JSON.parse(localStorage.getItem("accessibility"));
      let styleNode = document.createElement('style');
      styleNode.type = "text/css";
      styleNode.title = "subtitles";
      let styleText = document.createTextNode('.shaka-text-container span { color: ' + settings.fontColor + ' !important; background: ' + settings.bgColor + ' !important; font-size: ' + settings.fontSize + ' !important} ');
      styleNode.appendChild(styleText);
      document.getElementsByTagName('head')[0].appendChild(styleNode);
    }
  }

  /** Remove the accessibility subtitles style */
  private removeSubtitlesStyle() {
    let allStyles = document.getElementsByTagName("style");
    for (let i = 0; i < allStyles.length; i++) {
      if (allStyles[i].title && allStyles[i].title == "subtitles") {
        allStyles[i].remove();
      }
    }
  }

  /** Create custom button for COWATCH feature */
  private createCoWatchButton() {
    let self = this;
    // Use shaka.ui.Element as a base class
    shaka.ui.SkipButton = class extends shaka.ui.Element {
      constructor(parent, controls) {
        super(parent, controls);
        // The actual button that will be displayed
        this.button_ = document.createElement('button');
        this.button_.className = "fa fa-users";
        this.parent.appendChild(this.button_);

        this.eventManager.listen(this.button_, 'click', () => {
          self.openCoWatch = !self.openCoWatch;
        });
      }
    };

    // Factory that will create a button at run time.
    shaka.ui.SkipButton.Factory = class {
      create(rootElement, controls) {
        return new shaka.ui.SkipButton(rootElement, controls);
      }
    };

    // Register our factory with the controls, so controls can create button instances.
    shaka.ui.Controls.registerElement('cowatch', new shaka.ui.SkipButton.Factory());
  }

  /** Get advertisment based on an adSlot */
  getBannerAd(adSlot) {
    if (adSlot?.ads) {
      const randomVal = Math.floor(Math.random() * adSlot.ads.length);
      this.adverticalService.getBanner("Player_Banner&contentId=" + adSlot.ads[randomVal], "PLAYER_BANNER", true);
    }
  }
}